function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 73,
  r: 73,
  fill: "#FFD747"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "place_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 146,
  height: 146
}, /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 73,
  r: 73,
  fill: "#FFD747"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.708 44.875c0-9.836 7.956-17.792 17.792-17.792 9.836 0 17.792 7.956 17.792 17.792 0 13.344-17.792 33.042-17.792 33.042S84.708 58.219 84.708 44.875zm11.438 0a6.356 6.356 0 006.354 6.354 6.357 6.357 0 006.354-6.354 6.357 6.357 0 00-6.354-6.354 6.356 6.356 0 00-6.354 6.354z",
  fill: "#FF757B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M68.131 82c1.705.047 3.417.05 5.121.15 10.782.637 20.198 4.579 28.253 11.795 3.515 3.152 6.43 6.783 8.819 10.849.179.308.386.594.665 1.025 1.459-2.823 2.867-5.54 4.412-8.528.917 2.879 1.764 5.5 2.574 8.134.073.232-.026.563-.141.798-2.161 4.236-4.339 8.459-6.558 12.777-.402-.176-.763-.307-1.107-.488-3.763-1.936-7.535-3.853-11.268-5.849-.52-.28-1.022-.875-1.218-1.437-.852-2.395-1.586-4.831-2.44-7.476 1.862.95 3.513 1.793 5.234 2.666-1.568-5.441-13.976-13.593-23.787-14.956-17.097-2.376-29.935 4.508-39.007 19.172-2.493-1.314-5.055-2.663-7.683-4.051 2.958-5.473 6.697-10.157 11.438-14.027 6.115-4.996 13.01-8.298 20.795-9.681 1.563-.278 3.133-.526 4.703-.79.393-.03.796-.057 1.195-.083z",
  fill: "#005646"
});

function SvgPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgPlace;